import React, { useEffect, useContext, useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Typography, MenuItem, Button } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import userImage from "../../assets/images/user4.png";
import bell4 from "../../assets/images/bell4.png";
import IconBackArrow from "../../assets/images/IconBackArrow.png";
import red from "../../assets/images/red.svg";
import { Link, useLocation, useHistory } from "react-router-dom";
import { DataManagerContext } from "../../context/DataManagerContext";
import Menu from "@material-ui/core/Menu";
import { AuthContext } from "../../context/AuthContext";
import axios from "axios";
import RefreshToken from "../RefreshToken";
// import ListItemIcon from "@material-ui/core/ListItemIcon";
// import ListItemText from "@material-ui/core/ListItemText";
const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
    paddingRight: 8,
    paddingLeft: 8,
    width: "250px",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      // backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },

    "&:hover": {
      background: "rgba(156, 56, 54, 0.12)",
    },
    margin: "5px 0",
    fontSize: "14px",

    // background:'white',
  },
}))(MenuItem);

const useStyles = makeStyles((theme) => ({
  flexStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "black",
    height: "65px",
    padding: "0px 25px 0 32px",
  },
  flexStyle2: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    color: "black",
    // marginTop: 22,
    height: "100%",
  },
  leftItemPadding: {
    padding: "0 40px 0 0",
  },
  rightItemPadding: {
    padding: "0 0 0 15px",
    cursor: "pointer",
  },
  bell: {
    padding: "10px 0 0 15px",
    cursor: "pointer",
    position: "relative",
  },
  red: {
    position: "absolute",
    top: 4,
    right: -7,
  },
  buttonItemPadding: {
    padding: "0 0 0 10px",
  },
  menuItem: {
    borderBottom: "1px solid #eee",
    cursor: "default",
  },
  backButton: {
    fontSize: "16px",
    textTransform: "capitalize",
    "&:hover": {
      background: "none",
    },
    color: "#19181699",
  },
  imageStyle: {
    borderRadius: "50%",
  },
}));
const Topbar = () => {
  const classes = useStyles();
  let location = useLocation();
  let history = useHistory();
  let path = location.pathname;
  const { myData } = useContext(DataManagerContext);
  console.log("myData", myData);
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { glob_pay_agent_auth, logout, login } = useContext(AuthContext);

  const [balance, setBalance] = useState("");

  const getBalance = async () => {
    let token = await RefreshToken(glob_pay_agent_auth, logout, login);

    try {
      let res = await axios({
        url: "/api/v1/private/account/balance",
        method: "get",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setBalance(res.data.data);
    } catch (error) {
      console.log("err", error.response);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const redirectToResetPassword = () => {
    setAnchorEl(null);
    history.push("/reset-password");
  };

  const redirectToAccountSettings = () => {
    setAnchorEl(null);
    history.push("/account-settings");
  };

  const fnSetMessage = () => {
    if (path === "/home") {
      return (
        <Typography variant="h6" style={{ fontWeight: 600 }}>
          Welcome Back!
        </Typography>
      );
    } else if (path === "/help-center" || path === "/account-settings") {
      return (
        <Button
          component={Link}
          to="/home"
          className={classes.backButton}
          startIcon={<img src={IconBackArrow} alt="" />}
          disableRipple={true}
        >
          Back
        </Button>
      );
    } else if (
      path === "/money-deposited" ||
      path === "/money-transfer" ||
      path === "/money-picked"
    ) {
      if (myData.step === 3) {
        return (
          <Button
            component={Link}
            to="/home"
            className={classes.backButton}
            startIcon={<img src={IconBackArrow} alt="" />}
            disableRipple={true}
          >
            Back
          </Button>
        );
      }
    } else {
      return <div></div>;
    }
  };
  useEffect(() => {
    fnSetMessage();
    getBalance();
  }, [path]);
  return (
    <div>
      <div className={classes.flexStyle}>
        <div style={{ flex: 1 }}>
          <div className={classes.leftItemPadding}>{fnSetMessage()}</div>
        </div>
        <div style={{ flex: 2 }}>
          <div className={classes.flexStyle2}>
            <Typography
              varient="body1"
              style={{
                padding: "10px 15px",
                background: "rgba(156, 56, 54, 0.2)",
                borderRadius: "5px",
                lineHeight: "10px",
              }}
            >
              Balance:
              <strong>{balance.balance} {balance.currency}</strong>
            </Typography>
            <div className={classes.bell}>
              <img src={bell4} alt="" />
              <img src={red} alt="" className={classes.red} />
            </div>
            <div className={`${classes.flexStyle} ${classes.rightItemPadding}`}>
              <div className={classes.buttonItemPadding}>
                <Button
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  style={{
                    backgroundColor: "transparent",
                  }}
                >
                  <img
                    style={{ width: 40 }}
                    src={
                      glob_pay_agent_auth &&
                      glob_pay_agent_auth.user &&
                      glob_pay_agent_auth.user.picture
                        ? glob_pay_agent_auth.user.picture
                        : userImage
                    }
                    alt=""
                    className={classes.imageStyle}
                  />
                  {}
                  <span
                    style={{
                      marginLeft: 15,
                      fontSize: "1.2rem",
                      color: "#666",
                      textTransform: "capitalize",
                    }}
                  >
                    {glob_pay_agent_auth &&
                      glob_pay_agent_auth.user &&
                      glob_pay_agent_auth.user.name}
                  </span>
                  <ExpandMoreIcon style={{ color: "#666" }} />
                </Button>
                <StyledMenu
                  id="simple-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  // style={{background:'green'}}
                >
                  <StyledMenuItem onClick={redirectToAccountSettings}>
                    Account Settings
                  </StyledMenuItem>
                  <StyledMenuItem onClick={(e) => logout()}>
                    Logout
                  </StyledMenuItem>
                </StyledMenu>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
